import { render, staticRenderFns } from "./ThankYouChina.vue?vue&type=template&id=43e2136d&scoped=true&"
var script = {}
import style0 from "./ThankYouChina.vue?vue&type=style&index=0&id=43e2136d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e2136d",
  null
  
)

export default component.exports